"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FinanceReconciliationSubPartnersList_1 = require("./FinanceReconciliationSubPartnersList");
var FinanceReconciliationPartnersDetailExpander = /** @class */ (function (_super) {
    __extends(FinanceReconciliationPartnersDetailExpander, _super);
    function FinanceReconciliationPartnersDetailExpander(props) {
        var _this = _super.call(this, props) || this;
        _this.key_editor = "key.editor";
        return _this;
    }
    FinanceReconciliationPartnersDetailExpander.prototype.componentWillMount = function () {
        this.setState({
            tabKey: this.key_editor
        });
    };
    FinanceReconciliationPartnersDetailExpander.prototype.getEditorContent = function () {
        return (React.createElement(FinanceReconciliationSubPartnersList_1.default, { state: this.props.state, errDialog: this.props.errDialog, record: this.props.record }));
    };
    FinanceReconciliationPartnersDetailExpander.prototype.getContent = function () {
        if (this.state.tabKey === this.key_editor) {
            return this.getEditorContent();
        }
        return null;
    };
    FinanceReconciliationPartnersDetailExpander.prototype.tabChangeClick = function (key) {
        this.setState({ tabKey: key });
    };
    FinanceReconciliationPartnersDetailExpander.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { style: { width: "100%", height: "100%" } },
            React.createElement(antd_1.Card, { bordered: true, hoverable: false, style: { height: "80%", width: "100%" }, tabList: [
                    { key: this.key_editor, tab: "\u0421\u0443\u0431\u043F\u0430\u0440\u0442\u043D\u0435\u0440\u044B: [" + this.props.record.usr_partner_login + "]" }
                ], activeTabKey: this.state.tabKey, onTabChange: function (key) { _this.tabChangeClick(key); } }, this.getContent())));
    };
    return FinanceReconciliationPartnersDetailExpander;
}(React.Component));
exports.default = FinanceReconciliationPartnersDetailExpander;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_reconciliations/ui/component/FinanceReconciliationPartnersDetailExpander.tsx
// module id = 832
// module chunks = 0